import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=38271cce&scoped=true&"
import script from "./ImageCropper.vue?vue&type=script&lang=js&"
export * from "./ImageCropper.vue?vue&type=script&lang=js&"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=38271cce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38271cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
